import { Edit as ReactEdit } from 'react-admin';

const Edit = ReactEdit;

Edit.defaultProps = {
	undoable: false
};

export default Edit;
